import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import PaymentIcon from '@stubhub/react-payment-icon';

import {getPaymentIcons} from './utils/utils';

import '../styles/index.scss';

/** Displays a list of icons related to the available payment methods passed in the `methods` property. The title is optional based on the `showHeader` prop */
const PaymentMethods = ({showHeader, showBorder = true, methods}) => {
  const paymentIcons = useMemo(() => getPaymentIcons(methods) || [], [methods]);

  const header = <FormattedMessage id="buy.react-trust-messaging.paymentMethods.title" defaultMessage="Pay with:" />;

  return (
    <div className="PaymentMethods">
      {showHeader && <div className="PaymentMethods__header">{header}</div>}
      <ul className="PaymentMethods__images">
        {paymentIcons.map((icon) => {
          let iconName = '';
          if (icon === 'GooglePayMark') {
            iconName = !showBorder ? 'GooglePayBorderless' : icon;
          } else {
            iconName = !showBorder ? `${icon}Borderless` : icon;
          }

          return (
            <li key={iconName} className="PaymentMethods__images__icon">
              <PaymentIcon type={iconName} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

PaymentMethods.propTypes = {
  /** Show block header? */
  showHeader: PropTypes.bool,

  /** Array of available payment methods */
  methods: PropTypes.array,

  /** If icons present border or not */
  showBorder: PropTypes.bool,
};

export default PaymentMethods;
